export const DATA_HOOKS = {
    Next: 'next-arrow',
    Prev: 'prev-arrow',
    Text: 'caption-text',
};
//# sourceMappingURL=constants.js.map